/**
 * Ensures indicator names are unique. When creating (or when a generated name would conflict),
 * appends " #02", " #03", etc. to the base name.
 * @param baseName - Desired name (e.g. generated display name or symbol).
 * @param existingIndicators - All current indicators (or subset when excluding one).
 * @param excludeId - If set, ignore the indicator with this id when checking for conflicts (e.g. when updating that indicator).
 */
export function getUniqueIndicatorName(
  baseName: string,
  existingIndicators: { id: string; name: string }[],
  excludeId?: string
): string {
  const names = new Set(
    existingIndicators
      .filter((i) => i.id !== excludeId)
      .map((i) => i.name)
  );
  if (!names.has(baseName)) return baseName;
  let n = 2;
  const suffix = () => ` #${String(n).padStart(2, '0')}`;
  while (names.has(baseName + suffix())) n++;
  return baseName + suffix();
}
